import { DateRangeEnum } from "types/topicflow";

export enum RecognitionBoardExtraDateRangeEnum {
  all = "all",
  custom = "custom",
}

export type RecognitionBoardDateRangeType =
  | RecognitionBoardExtraDateRangeEnum
  | DateRangeEnum;
